import React from "react";
import { Box } from "@mui/material";
import { Search } from "./../";
import { Container } from "@mui/system";

function Banner({
	image,
	video,
	search = false,
	searchPlaceholder,
	size = "md",
}) {
	return (
		<Box
			className={`size-${size} banner ${video ? "has-video" : ""}`}
			sx={{
				backgroundImage: `url(${image.src})`,
				paddingTop: "28%",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center center",
				backgroundSize: "cover",
				WebkitBackgroundSize: "cover",
				position: "relative",
				"&.size-sm": {
					paddingTop: "16.7%",
				},
				"&.size-lg": {
					paddingTop: "50%",
				},
			}}
		>
			{video && (
				<video
					autoPlay
					muted
					loop
					playsInline
					src={video.url}
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
				/>
			)}
			{!!search && (
				<Box
					sx={(theme) => ({
						position: "absolute",
						top: "50%",
						left: 0,
						width: "100%",
						marginTop: theme.spacing(-3.5),
						"& form": {
							marginTop: 0,
						},
					})}
				>
					<Container maxWidth="xs">
						<Search placeholder={searchPlaceholder} variant="filled" />
					</Container>
				</Box>
			)}
		</Box>
	);
}

export default Banner;
